import React from 'react'
import { Button, Card, Col, Row } from 'antd'
import { useNavigate } from 'react-router-dom'
import { SlArrowRight } from 'react-icons/sl'
import OrgLogo from '../../common/components/Logo/OrganizationLogo'
import FooterAllRights from '../../common/components/Footer/FooterAllRights'
import GlobalHeader from '../../common/components/Header/GlobalHeader'
import { portalAccentGhostButtonStyle, useTheme, useThemeColors } from '../../common/ThemeContext'

const ArrowRightIcon = SlArrowRight as unknown as React.ComponentType

function CheckInCheckOut() {
	const navigate = useNavigate()
	const { theme } = useTheme()
	const themeColors = useThemeColors()
	const ghostBtn = portalAccentGhostButtonStyle(theme, themeColors.primary)

	const navToCheckIn = () => {
		navigate('/checkin')
	}

	const navToCheckOut = () => {
		navigate('/checkout')
	}

	return (
		<>
			<GlobalHeader />
			<div
				style={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					minHeight: 'calc(100vh - 120px)',
				}}
			>
				<Card
					style={{
						width: '90%',
						maxWidth: '400px',
						textAlign: 'center',
						borderRadius: '12px',
						boxShadow: themeColors.cardShadow,
						background: themeColors.bg,
						borderColor: themeColors.border,
					}}
				>
					<OrgLogo style={{ marginBottom: '10px', width: '100px' }} />

					<Row style={{ marginTop: '30px' }} gutter={[16, 16]}>
						<Col xs={24}>
							<Button
								icon={<ArrowRightIcon />}
								iconPosition='end'
								block
								size='large'
								onClick={navToCheckIn}
								style={{
									...ghostBtn,
									height: '50px',
									fontSize: '18px',
									width: '100%',
								}}
							>
								Check-In
							</Button>
						</Col>
						<Col xs={24}>
							<Button
								icon={<ArrowRightIcon />}
								iconPosition='end'
								block
								size='large'
								onClick={navToCheckOut}
								style={{
									...ghostBtn,
									height: '50px',
									fontSize: '18px',
									width: '100%',
								}}
							>
								Check-Out
							</Button>
						</Col>
					</Row>

					<FooterAllRights style={{ marginTop: '20px', fontSize: '12px' }} />
				</Card>
			</div>
		</>
	)
}

export default CheckInCheckOut
